import { COLORS } from "../../theme/colors";

export const UNREALIZED_LEGENDS = {
  UNCONNECTED_TENANTS: "unconnected_tenants",
  VACANCY: "vacancy",
  BATTERY: "battery",
  EV: "ev",
  SOLAR: "solar",
  NEW_POWER_ASSET: "new_power_asset",
  NEW_POWER_REVENUES: "new_power_revenues",
};

export const UNREALIZED_COLORS = {
  [UNREALIZED_LEGENDS.UNCONNECTED_TENANTS]: "#E5D0B0",
  [UNREALIZED_LEGENDS.VACANCY]: "#E4DCD1",
  [UNREALIZED_LEGENDS.BATTERY]: COLORS.majorelleBlue,
  [UNREALIZED_LEGENDS.EV]: "#63B9C4",
  [UNREALIZED_LEGENDS.SOLAR]: COLORS.lightYellow,
  [UNREALIZED_LEGENDS.NEW_POWER_ASSET]: "#B7EBBC",
  [UNREALIZED_LEGENDS.NEW_POWER_REVENUES]: "#B7EBBC",
};
